import { Reveal, Kicker } from "./Reveal";

const LEVELS = [
  ["L1", "RECOMMEND ONLY", "Every proposal routes to a human.", "Purpose: establish recommendation quality.", false],
  ["L2", "APPROVE TO EXECUTE", "A human approves the recommendation. PriceStrike performs the execution.", "Purpose: establish execution reliability.", false],
  ["L3", "AUTO WITHIN BOUNDS", "PriceStrike executes automatically when the approved policy allows it.", "Purpose: establish bounded machine delegation.", true],
];

export default function Autonomy() {
  return (
    <section id="autonomy" className="border-b border-white/10 bg-[#0A0A0B]" data-testid="autonomy-section">
      <div className="mx-auto max-w-[1600px] px-6 py-28 lg:px-12 lg:py-40">
        <Reveal>
          <Kicker index="06" label="Earned autonomy" />
          <h2 className="max-w-5xl font-display text-4xl font-extrabold leading-[1.02] tracking-tighter sm:text-5xl lg:text-6xl" data-testid="autonomy-heading">
            Customers never have to trust <span className="text-[#00FF41]">before there is evidence.</span>
          </h2>
        </Reveal>

        <div className="mt-20 grid border border-white/10 md:grid-cols-3">
          {LEVELS.map(([lvl, title, desc, purpose, active], i) => (
            <Reveal key={lvl} delay={i * 0.1} className="border-b border-white/10 p-10 transition-colors duration-500 last:border-b-0 hover:bg-[#0F0F11] md:border-b-0 md:border-r md:last:border-r-0">
              <div className="flex items-center gap-3">
                <span className={`h-2 w-2 rounded-full ${active ? "bg-[#00FF41] glow-dot" : "bg-zinc-700"}`} />
                <span className="font-display text-4xl font-extrabold tracking-tighter" data-testid={`autonomy-level-${lvl.toLowerCase()}`}>{lvl}</span>
                {active && <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#00FF41]">Target state</span>}
              </div>
              <div className="mt-6 font-mono text-xs uppercase tracking-[0.2em] text-zinc-300">{title}</div>
              <p className="mt-3 font-mono text-xs leading-relaxed text-zinc-500">{desc}</p>
              <p className="mt-6 border-t border-white/10 pt-4 font-mono text-[11px] leading-relaxed text-[#00FF41]">{purpose}</p>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <p className="mt-10 max-w-3xl font-mono text-sm leading-relaxed text-zinc-400" data-testid="autonomy-closing">
            Progression itself is governed and recorded.{" "}
            <span className="text-white">As evidence improves, customers can voluntarily increase autonomy.</span>
          </p>
        </Reveal>
      </div>
    </section>
  );
}
